// Constantes do regulamento oficial (Agentic League — Fase Pocket, 2026).
//
// Datas e prêmios extraídos do "AGENTIC LEAGUE - REGULAMENTO OFICIAL.md".
// Mantém apenas o que o regulamento define; bônus de velocidade foi removido
// porque não consta da edição vigente.

/** Fase Pocket: 3/ago/2026 a 18/set/2026 18:00 BRT. */
export const LEAGUE_START = new Date('2026-08-03T00:00:00-03:00');
export const LEAGUE_END = new Date('2026-09-18T18:00:00-03:00');

/** Anúncio dos vencedores: 21/set/2026. */
export const RANKING_PUBLISHED = new Date('2026-09-21T00:00:00-03:00');
/** Pagamento dos prêmios até 21/out/2026. */
export const PRIZE_PAYMENT_DEADLINE = new Date('2026-10-21T23:59:59-03:00');
/** Cerimônia: mantida como alias do anúncio até o regulamento detalhar. */
export const AWARD_CEREMONY = RANKING_PUBLISHED;

export const ADMIN_EMAILS = [
  'davi.peterlini@ciandt.com',
  'elenoliveira@ciandt.com',
  'maiaramr@ciandt.com',
  'rafaelff@ciandt.com',
  'vitoriacn@ciandt.com',
  'gmarconi@ciandt.com',
];

export const PROGRESS_STORAGE_KEY = 'agentic_league_progress';
export const AUTH_STORAGE_KEY = 'agentic_league_auth';

/**
 * Valor (USD) de cada prêmio sorteado por posição da GU no Top 3 (§9.2).
 * O regulamento sorteia 3 prêmios deste valor por GU; além disso, todas as
 * pessoas certificadas concorrem a 4 prêmios de $50 (total geral: $1.550 USD).
 * Aqui guardamos apenas o valor unitário por posição — a contagem de sorteios
 * e o prêmio de consolação vivem na copy (não são renderizados a partir daqui).
 */
export const PRIZE_AMOUNTS_USD: Record<1 | 2 | 3, number> = { 1: 200, 2: 150, 3: 100 };

